import { useOktaAuth } from '@okta/okta-react';

/**
 * Returns true if the current user can access GovCloud accounts.
 * Requires orion_admin role OR users_orion_govcloud_reader Okta group.
 */
export function useIsGovCloudReader() {
  const { authState } = useOktaAuth();
  if (!authState?.isAuthenticated) return false;
  const roles = authState?.accessToken?.claims?.roles || [];
  const groups = authState?.accessToken?.claims?.groups || [];
  return roles.includes('orion_admin') || groups.includes('users_orion_govcloud_reader');
}
